import type { TOC } from '@ember/component/template-only';
import { not } from 'tio-ui/utilities';

interface CollapsibleSignature {
  Args: {
    isOpen?: boolean;
  };
  Element: HTMLDivElement;
  Blocks: { default: [] };
}

const Collapsible: TOC<CollapsibleSignature> = <template>
  <div hidden={{not @isOpen}} ...attributes>
    {{yield}}
  </div>
</template>;

export default Collapsible;
